import React, { useState } from "react";
import "../components/styles/startUpDetails.css";
import DataGridTable from "./DataTable/DataGridTable";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import CustomizedSnackbars from "../components/alert/alert";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
// import { useLocation } from "react-router-dom";
const DealDetails = () => {
    // const startupId = JSON.parse(localStorage.getItem("startUpId"))
    // const location = useLocation()
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [totalRows, setTotalRows] = useState(0);

    const [snackBarMsg, setSnackBarMsg] = useState({
        message: "",
        severity: "success",
        open: false,
    });
 
    const handleBack = () => {
        window.history.back()
    }
    const handlePageChange = (newPage) => {
        setPage(newPage.page);
        setPageSize(newPage.pageSize)
    };
    const columns = [
        {
            field: "meetingId",
            headerName: "Total Investment",
            width: 250,
            editable: false,
            renderCell: (rowData) => {
                return <div>{rowData?.row?.meetingId ? rowData?.row?.meetingId : "--"}</div>
            }
        },
        {
            field: "name",
            headerName: "Investment Date",
            width: 250,
            editable: false,
        },
        {
            field: "email",
            headerName: "Email Id",
            width: 250,
            editable: false,

        },
        {
            field: "mobile",
            headerName: "Mobile Number",
            width: 250,
            editable: false,
        },
        {
            field: "meetingStart",
            headerName: "Linkedin Profile",
            width: 250,
            editable: false,
        },
    ]
    return (

        <Box sx={{ marginLeft: '3%', marginRight: '3%', border: '1px solid grey', position: 'relative', top: '15%', height: 'fit-content' }}>

            <Box className="left" style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                <KeyboardBackspaceIcon sx={{ cursor: 'pointer' }} onClick={handleBack} />
                <img className="logo" style={{ width: '8vw', height: '10vh' }} src={""} alt="Incred" />
                <Box style={{ alignItems: 'center' }}>
                    <p style={{ marginTop: "22px" }}>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptatibus nobis sint expedita hic fugit dignissimos odio porro, nostrum unde voluptate, magni molestias animi nesciunt reiciendis possimus pariatur perferendis. Autem, error.</p>
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <button style={{ borderRadius: '6px' }}>DealRound</button>
                        <button style={{ borderRadius: '6px' }}>InvestmentDeal</button>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'top', position: 'relative', top: '20px', borderTop: '1px solid gray', paddingBottom: '20px' }}>
                <Box sx={{ width: '18vw', marginLeft: '1vw', display: 'block', borderRight: '1px solid gray', overflow: 'hidden' }}>
                    <Typography style={{ fontSize: '25px', fontWeight: '500' }}>Investor Details</Typography>
                    <Typography>Investor</Typography>
                </Box>
                <Box >
                    <Typography sx={{ paddingLeft: '30px', paddingRight: '30px', paddingTop: '20px' }}>Prince Gupta</Typography>
                    <DataGridTable
                        height="100%"
                        width="65vw"
                        data={rows}
                        columns={columns}
                        pageSize={pageSize}
                        rowCount={totalRows}
                        onPageChange={handlePageChange}
                        isOngoingDeal
                    />
                </Box>
            </Box>
            <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
        </Box>
    )
}

export default DealDetails;